import React, { createContext, useContext, useRef, useEffect } from "react";

const EventContext = createContext();

export const EventProvider = ({ children }) => {
  const listenersRef = useRef([]);

  const subscribe = (listener) => {
    listenersRef.current = [...listenersRef.current, listener];
    const unsubscribe = () => {
      listenersRef.current = listenersRef.current.filter((l) => l !== listener);
    };
    return { unsubscribe, listener };
  };

  const emit = (eventName, eventData) => {
    listenersRef.current.forEach((listener) => {
      listener(eventName, eventData);
    });
  };

  // Set global event emitter reference for websocket message handling
  useEffect(() => {
    if (typeof window !== "undefined") {
      window._wsEventEmitter = { emit };

      // Cleanup on unmount
      return () => {
        window._wsEventEmitter = null;
      };
    }
  }, []);

  return (
    <EventContext.Provider value={{ subscribe, emit }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventEmitter = () => useContext(EventContext);
